import React, { useState, useEffect } from "react";
import { formatUSD } from "../utils/priceAPI";
import styles from "../styles/EarningsPopup.module.css";

export interface EarningsData {
  usdAmount: number;
  bnbAmount: number;
  currentRow: number;
  totalRows: number;
  multiplier: number;
  totalEarnings: number;
}

interface EarningsPopupProps {
  earnings: EarningsData | null;
  onClose: () => void;
  duration?: number; // Auto-close duration in ms (default: 3000)
}

const EarningsPopup: React.FC<EarningsPopupProps> = ({ 
  earnings, 
  onClose, 
  duration = 3000 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (earnings) {
      setIsVisible(true);
      setIsClosing(false);

      // Auto-close after duration
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [earnings, duration]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 300);
  };

  if (!earnings || !isVisible) return null;

  return (
    <div
      className={`${styles.earningsPopup} ${isClosing ? styles.closing : ""}`}
      onClick={handleClose}
    >
        <div className={styles.earningsContent}>
          <div className={styles.earningsIcon}>💰</div>
          <div className={styles.earningsInfo}>
            <div className={styles.earningsTitle}>ROW {earnings.currentRow} CLEARED</div>
            <div className={styles.earningsAmount}>+{formatUSD(earnings.usdAmount)}</div>
          </div>
        </div>
    </div>
  );
};

export default EarningsPopup;